import React, { useCallback, useMemo } from 'react';

import styled from 'styled-components';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APIDocumentSearchResult, APIUserType } from '@cd3p/core/types/api';
import { Typography } from 'components';

import { useSelector, useTranslation } from 'third-party';

import { appSelectors } from 'selectors';

import { Docs } from 'features/Docs/Docs';

const Title = styled(Typography)`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 150%;
  color: ${props => props.theme.custom.palette.darkText};
`;

export const TermsAndConditionsDocs = () => {
  const { t } = useTranslation();

  const userType = useSelector(appSelectors.userType);

  const menuItemRenderer = useCallback(
    (it: APIDocumentSearchResult) => <Title>{it.document?.title}</Title>,
    [],
  );

  const documentsSection = useMemo(() => {
    return userType === APIUserType.Contractor
      ? DocumentsSections.TermsAndConditionsWebContractor
      : DocumentsSections.TermsAndConditionsWebDispatcher;
  }, [userType]);

  return (
    <Docs
      pageName={t('docs.legalAgreements')}
      menuItemRenderer={menuItemRenderer}
      documentsSection={documentsSection}
    />
  );
};
